import { RealtimeDatabase as Database } from "../../db/common";
import { ChatBookingService } from "./ChatBookingService";
import { ChatChannelService } from "./ChatChannelService";
import { ChatDirectIndexService } from "./ChatDirectIndexService";
import { ChatEventService } from "./ChatEventService";
import { ChatListingService } from "./ChatListingService";
import { ChatMessageService } from "./ChatMessageService";
import { ChatUserService } from "./ChatUserService";
import { UserChannelService } from "./UserChannelsService";

/**
 * Shared Chat Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatService {
    // Public service instances
    public readonly channels: ChatChannelService;
    public readonly messages: ChatMessageService;
    public readonly users: ChatUserService;
    public readonly userChannels: UserChannelService;
    public readonly directIndex: ChatDirectIndexService;
    public readonly listings: ChatListingService;
    public readonly bookings: ChatBookingService;
    public readonly events: ChatEventService;

    constructor(protected db: Database) {
        this.channels = new ChatChannelService(db);
        this.messages = new ChatMessageService(db);
        this.users = new ChatUserService(db);
        this.userChannels = new UserChannelService(db);
        this.directIndex = new ChatDirectIndexService(db);
        this.listings = new ChatListingService(db);
        this.bookings = new ChatBookingService(db);
        this.events = new ChatEventService(db);
    }
}